module.exports = __webpack_public_path__ + "static/media/stream.89c4c00e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/program/stream.png
// module id = 1195
// module chunks = 110